import { CertificateTemplate } from '../../../../interface';

export interface CertificateTemplateMeta {
  value: CertificateTemplate;
  label: string;
  shortLabel: string;
  description: string;
}

export const CERTIFICATE_TEMPLATES: CertificateTemplateMeta[] = [
  {
    value: CertificateTemplate.CERT_TEMPLATE_1,
    label: 'Option 1',
    shortLabel: 'Template 1',
    description: '',
  },
  {
    value: CertificateTemplate.CERT_TEMPLATE_2,
    label: 'Option 2',
    shortLabel: 'Template 2',
    description: '',
  },
  {
    value: CertificateTemplate.CERT_TEMPLATE_3,
    label: 'Option 3',
    shortLabel: 'Template 3',
    description: '',
  },
];

export const getCertificateTemplateMeta = (template?: CertificateTemplate | null) => (
  CERTIFICATE_TEMPLATES.find((item) => item.value === template) ?? CERTIFICATE_TEMPLATES[0]
);
